/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckPax } from './PaxCheckPax';
import {
    PaxCheckPaxFromJSON,
    PaxCheckPaxFromJSONTyped,
    PaxCheckPaxToJSON,
    PaxCheckPaxToJSONTyped,
} from './PaxCheckPax';
import type { PaxCheckChecklist } from './PaxCheckChecklist';
import {
    PaxCheckChecklistFromJSON,
    PaxCheckChecklistFromJSONTyped,
    PaxCheckChecklistToJSON,
    PaxCheckChecklistToJSONTyped,
} from './PaxCheckChecklist';
import type { PaxCheckRequiredAction } from './PaxCheckRequiredAction';
import {
    PaxCheckRequiredActionFromJSON,
    PaxCheckRequiredActionFromJSONTyped,
    PaxCheckRequiredActionToJSON,
    PaxCheckRequiredActionToJSONTyped,
} from './PaxCheckRequiredAction';

/**
 * Pax session (ie passenger)
 * @export
 * @interface PaxCheckPaxSession
 */
export interface PaxCheckPaxSession {
    /**
     * Pax session id (prefixed with 'pax_')
     * @type {string}
     * @memberof PaxCheckPaxSession
     */
    paxSessionId: string;
    /**
     * 
     * @type {PaxCheckRequiredAction}
     * @memberof PaxCheckPaxSession
     */
    requiredAction?: PaxCheckRequiredAction;
    /**
     * Consent response when provided (true: consented, false: didn't consent), null otherwise
     * @type {boolean}
     * @memberof PaxCheckPaxSession
     */
    consented?: boolean | null;
    /**
     * 
     * @type {PaxCheckPax}
     * @memberof PaxCheckPaxSession
     */
    pax: PaxCheckPax;
    /**
     * 
     * @type {PaxCheckChecklist}
     * @memberof PaxCheckPaxSession
     */
    checklist: PaxCheckChecklist;
    /**
     * Whether travel document requires verification
     * @type {boolean}
     * @memberof PaxCheckPaxSession
     */
    isTravelDocumentVerified: boolean;
}



/**
 * Check if a given object implements the PaxCheckPaxSession interface.
 */
export function instanceOfPaxCheckPaxSession(value: object): value is PaxCheckPaxSession {
    if (!('paxSessionId' in value) || value['paxSessionId'] === undefined) return false;
    if (!('pax' in value) || value['pax'] === undefined) return false;
    if (!('checklist' in value) || value['checklist'] === undefined) return false;
    if (!('isTravelDocumentVerified' in value) || value['isTravelDocumentVerified'] === undefined) return false;
    return true;
}

export function PaxCheckPaxSessionFromJSON(json: any): PaxCheckPaxSession {
    return PaxCheckPaxSessionFromJSONTyped(json, false);
}

export function PaxCheckPaxSessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckPaxSession {
    if (json == null) {
        return json;
    }
    return {
        
        'paxSessionId': json['pax_session_id'],
        'requiredAction': json['required_action'] == null ? undefined : PaxCheckRequiredActionFromJSON(json['required_action']),
        'consented': json['consented'] == null ? undefined : json['consented'],
        'pax': PaxCheckPaxFromJSON(json['pax']),
        'checklist': PaxCheckChecklistFromJSON(json['checklist']),
        'isTravelDocumentVerified': json['is_travel_document_verified'],
    };
}

export function PaxCheckPaxSessionToJSON(json: any): PaxCheckPaxSession {
    return PaxCheckPaxSessionToJSONTyped(json, false);
}

export function PaxCheckPaxSessionToJSONTyped(value?: PaxCheckPaxSession | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pax_session_id': value['paxSessionId'],
        'required_action': PaxCheckRequiredActionToJSON(value['requiredAction']),
        'consented': value['consented'],
        'pax': PaxCheckPaxToJSON(value['pax']),
        'checklist': PaxCheckChecklistToJSON(value['checklist']),
        'is_travel_document_verified': value['isTravelDocumentVerified'],
    };
}

